import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { clearLocalStorage, getDataFromJwt } from "../../utils/utility";
import { useSelector } from "react-redux";

export default function DashboardMenu() {
	const navigate = useNavigate();
	const [isCollapsed, setIsCollapsed] = useState(true);
	const [isActiveField, setIsActiveField] = useState("");
	const currentProfile = useSelector((state) => state.auth.currentProfile);
	const currenturl = useLocation();

	let UserMenu = [
		{
			name: "Home",
			image: "../../assets/images/bat-img/profilemenu/home.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/home-white.svg",
			urlPath: "/dashboard",
		},
		{
			name: currentProfile?.profile === "groom" ? "Bride" : "Groom",
			image:
				currentProfile?.profile === "groom"
					? "../../assets/images/bat-img/profilemenu/bride.svg"
					: "../../assets/images/bat-img/profilemenu/groom.svg",
			imageWhite:
				currentProfile?.profile === "groom"
					? "../../assets/images/bat-img/profilemenu/bride-white.svg"
					: "../../assets/images/bat-img/profilemenu/groom-white.svg",
			urlPath: "/dashboard/profile-filter",
		},
		{
			name: "My Shortlists",
			image: "../../assets/images/bat-img/profilemenu/shortlist.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/shortlist-white.svg",
			urlPath: "/dashboard/profile-shortlist",
		},
		{
			name: "Become a BAT Member",
			image: "../../assets/images/bat-img/profilemenu/become-member.svg",
			imageWhite:
				"../../assets/images/bat-img/profilemenu/become-member-white.svg",
			urlPath: "/dashboard/upgrade-to-bat",
			hideForRole: 3,
		},
		{
			name: "Logout",
			image: "../../assets/images/bat-img/profilemenu/logout.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/logout-white.svg",
		},
	];

	// {
	//     name: "Chat",
	//     image: "../../assets/images/bat-img/profilemenu/chat.svg",
	//     imageWhite: "../../assets/images/bat-img/profilemenu/chat-white.svg",
	//     urlPath: "/dashboard/chat",
	//   },
	//   {
	//     name: "Feedback",
	//     image: "../../assets/images/bat-img/profilemenu/feedback.svg",
	//     imageWhite: "../../assets/images/bat-img/profilemenu/feedback-white.svg",
	//   },
	const VolunteerMenu = [
		{
			name: "Home",
			image: "../../assets/images/bat-img/profilemenu/home.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/home-white.svg",
			urlPath: "/volunteer",
		},
		{
			name: "Profiles",
			image: "../../assets/images/bat-img/profilemenu/profile.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/profile-white.svg",
			urlPath: "/volunteer/profile-filter",
		},
		{
			name: "Matrimony Accounts",
			image: "../../assets/images/bat-img/profilemenu/bride.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/bride-white.svg",
			urlPath: "/volunteer/matrimony-accounts",
		},
		{
			name: "BAT Accounts",
			image: "../../assets/images/bat-img/profilemenu/account.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/account-white.svg",
			urlPath: "/volunteer/bat-accounts",
		},
		{
			name: "Logout",
			image: "../../assets/images/bat-img/profilemenu/logout.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/logout-white.svg",
		},
	];
	const AdminMenu = [
		{
			name: "Home",
			image: "../../assets/images/bat-img/profilemenu/home.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/home-white.svg",
			urlPath: "",
		},
		{
			name: "Profiles",
			image: "../../assets/images/bat-img/profilemenu/profile.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/profile-white.svg",
			urlPath: "/admin/profile-filter",
		},
		{
			name: "Matrimony Accounts",
			image: "../../assets/images/bat-img/profilemenu/bride.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/bride-white.svg",
			urlPath: "/admin/matrimony-accounts",
		},
		// {
		//   name: "Accounts Pending Approval",
		//   image: "../../assets/images/bat-img/profilemenu/bride.svg",
		//   imageWhite: "../../assets/images/bat-img/profilemenu/bride-white.svg",
		//   urlPath: "/admin/account-list",
		// },
		{
			name: "BAT Accounts",
			image: "../../assets/images/bat-img/profilemenu/account.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/account-white.svg",
			urlPath: "/admin/bat-accounts",
		},
		{
			name: "Volunteer List",
			image: "../../assets/images/bat-img/profilemenu/volunteer.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/volunteer-white.svg",
			urlPath: "/admin/volunteer-list",
		},
		// {
		//   name: "Pending Approval",
		//   image: "../../assets/images/bat-img/profilemenu/shortlist.svg",
		//   imageWhite: "../../assets/images/bat-img/profilemenu/shortlist-white.svg",
		//   urlPath: "/admin/profile-list",
		// },
		// {
		//   name: "Feedback",
		//   image: "../../assets/images/bat-img/profilemenu/feedback.svg",
		//   imageWhite: "../../assets/images/bat-img/profilemenu/feedback-white.svg",
		// },
		{
			name: "Payment Details",
			image: "../../assets/images/bat-img/dollar-sign-grey.svg",
			imageWhite: "../../assets/images/bat-img/dollar-sign-white.svg",
			urlPath: "/admin/subscription-details",
		},
		{
			name: "Logout",
			image: "../../assets/images/bat-img/profilemenu/logout.svg",
			imageWhite: "../../assets/images/bat-img/profilemenu/logout-white.svg",
		},
	];

	const toggleSidebar = () => {
		setIsCollapsed(!isCollapsed);
	};
	let roleId = getDataFromJwt("role");

	if (roleId == 3) {
		UserMenu = UserMenu.filter((menu) => menu.hideForRole !== 3);
	}

	let MenuData;
	if (roleId === 1) {
		MenuData = AdminMenu;
	} else if (roleId === 2) {
		MenuData = VolunteerMenu;
	} else {
		MenuData = UserMenu;
	}
	useEffect(() => {
		MenuData = UserMenu;
	}, [currentProfile]);

	function moveUser(item) {
		if (item?.name === "Logout") {
			clearLocalStorage();
		} else {
			navigate(item?.urlPath);
		}
		let screen = window.screen;
		let isMobile = screen.width < 1000;
		if (isMobile) toggleSidebar();
	}

	return (
		<div
			id="sidebar"
			style={{ minWidth: isCollapsed ? "80px" : "250px" }}
			className={`sidebar ${isCollapsed ? "collapsed" : ""}`}
		>
			<div className="sidebar-header">
				<button
					className={
						isCollapsed ? "toggle-btn nav-fixed" : "toggle-btn open nav-fixed"
					}
					onClick={toggleSidebar}
				>
					{/* <img
            src={
              isActiveField === "toggle"
                ? "../../assets/images/bat-img/toggle-white.svg"
                : "../../assets/images/bat-img/toggle.svg"
            }
            alt="BAT Logo"
            className="nav-links-icon toggle-icon"
            onMouseOver={() => setIsActiveField("toggle")}
            onMouseOut={() => setIsActiveField("")}
          /> */}
				</button>
			</div>
			<ul className="nav-links nav-fixed">
				{MenuData?.map((item, index) => (
					<li
						key={index}
						onMouseOver={() => setIsActiveField(item.name)}
						onMouseOut={() => setIsActiveField("")}
						className={currenturl.pathname == item?.urlPath ? "navActive" : ""}
						onClick={() => {
							moveUser(item);
						}}
					>
						<img
							src={isActiveField !== item?.name ? item.image : item?.imageWhite}
							className="nav-links-icon"
							alt={item?.name}
							title={item?.name}
						/>
						<span className={isCollapsed ? "hide-text" : ""}>{item?.name}</span>
					</li>
				))}
			</ul>
		</div>
	);
}
